'use client'

import { useState } from 'react'
import { cn } from '@/lib/utils'
import { ChevronDown } from 'lucide-react'

interface FaqItem {
  id: string
  question: string
  answer: string
}

interface FaqBlockContent {
  title?: string
  items: FaqItem[]
}

interface FaqBlockProps {
  content: FaqBlockContent
  className?: string
}

export function FaqBlock({ content, className }: FaqBlockProps) {
  const [openId, setOpenId] = useState<string | null>(null)

  if (!content.items || content.items.length === 0) return null

  const toggle = (id: string) => {
    setOpenId(openId === id ? null : id)
  }

  return (
    <div className={cn('space-y-3', className)}>
      {content.title && (
        <h3 className="text-lg font-semibold text-white">{content.title}</h3>
      )}
      <div className="space-y-2">
        {content.items.map((item) => (
          <div
            key={item.id}
            className="border border-zinc-700/50 rounded-lg overflow-hidden"
          >
            <button
              onClick={() => toggle(item.id)}
              className="w-full flex items-center justify-between p-4 text-left hover:bg-zinc-800/30 transition-colors"
            >
              <span className="text-white font-medium text-sm pr-4">{item.question}</span>
              <ChevronDown
                className={cn(
                  'h-4 w-4 text-zinc-400 flex-shrink-0 transition-transform',
                  openId === item.id && 'rotate-180'
                )}
              />
            </button>
            {openId === item.id && (
              <div className="px-4 pb-4 text-sm text-zinc-400 border-t border-zinc-700/30 pt-3">
                {item.answer}
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  )
}
